import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Software Engineer </span>
            from <span className="purple"> Seoul, Korea.</span>
            <br /> I am a junior student pursuing an Computing Science at Hanyang University.
            <br />
            I am currently employed as a Fullstack developer at <span className="purple">Fleetune</span>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> World of Warcraft
            </li>
            <li className="about-activity">
              <ImPointRight /> Lost Ark
            </li>
            <li className="about-activity">
              <ImPointRight /> Chess.com
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "challenging my experience with a sense of responsibility!"{" "}
          </p>
          <footer className="blockquote-footer">Lavi</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
